<template>
    <div
        :data-component="$options.name"
        class="flex items-center min-h-52 max-h-52"
    >
        <cs-copy-text-link
            v-if="showReportButton"
            class="text-text-l"
            data-jest-report
            @click="openReportModal"
            >Inhalt melden</cs-copy-text-link
        >
        <div
            class="relative flex ml-auto items-center cursor-pointer h-52 mr-8"
            data-jest-print
            @click="printExpose"
        >
            <ms-print class="w-24 h-24 m-10" />
        </div>

        <div
            class="relative flex items-center cursor-pointer h-52 mr-8"
            data-jest-share
            @click="openShare"
        >
            <ms-social-share class="w-24 h-24 m-10" />
        </div>
        <ms-like-button
            class="h-52"
            :decoratedEstate="estate"
            :componentId="parentName"
        />
        <ms-detail-modal-report
            :isVisible="modalIsVisible"
            :exposeeId="exposeeId"
            @closeModal="closeModal"
        />
        <cs-share-modal
            v-model:isVisible="isShareVisible"
            :url="currentUrl"
            :title="headline"
            :description="text"
            :shareTrackingData="shareTrackingData"
            :openTrackingData="openTrackingData"
        />
    </div>
</template>
<script lang="ts" src="./MsShareBar.ts" />
<style scoped lang="scss" src="./MsShareBar.scss" />
<!-- we have to overwrite component's flex-start -->
<style scoped>
a.ms-textLink {
    @apply items-center;
}
</style>
